import { eur } from "@/lib/format";
import { backendUrl } from "@/lib/api";

const TONO = { Pagata: "text-[#1B3A22]", "Non pagata": "text-[#8A2E2E]", Annullata: "text-[#5A5A5A]" };
const viewUrl = (docId) => `${backendUrl}/api/documenti/${docId}/download?inline=1&token=${localStorage.getItem("rb_token")}`;

function Cifra({ etichetta, valore, spiega, tono, testid, fondo }) {
  return (
    <div data-testid={testid} className="cifra" style={fondo ? { background: "#F7F6F2" } : undefined}>
      <span className="eti">{etichetta}</span>
      <b className={tono}>{eur(valore)}</b>
      <small>{spiega}</small>
    </div>
  );
}

// Gli stessi quattro numeri della scheda pratica, sommati su tutte le pratiche del cliente.
export default function ClienteContabilita({ c, documenti, onAzione }) {
  return (
    <>
      <div className="cifre" data-testid="cliente-cifre">
        <Cifra testid="cliente-valore" etichetta="Valore pratiche" valore={c.valore} tono="text-[#1B2A4B]"
          spiega={`${c.n_pratiche} pratic${c.n_pratiche === 1 ? "a" : "he"}`} />
        <Cifra testid="cliente-incassato" etichetta="Incassato" valore={c.incassato} tono="text-[#2E5E3A]"
          spiega={c.n_incassi === 0 ? "nessun incasso" : `${c.n_incassi} incass${c.n_incassi === 1 ? "o" : "i"}`} />
        <Cifra testid="cliente-da-incassare" etichetta="Da incassare" valore={c.da_incassare} tono="text-[#1A1A1A]" fondo
          spiega={c.da_incassare <= 0 ? "niente in sospeso" : "valore meno incassato"} />
        <Cifra testid="cliente-spese" etichetta="Spese" valore={c.spese} tono="text-[#1A1A1A]"
          spiega={c.spese > 0 ? "spese e onorari a terzi" : "nessuna spesa registrata"} />
      </div>

      <div className="flex flex-wrap gap-2.5">
        <button data-testid="cliente-apri-incasso" onClick={() => onAzione("incasso")} className="btn btn-p flex-[1_1_220px]">Registra incasso</button>
        <button data-testid="cliente-apri-spesa" onClick={() => onAzione("spesa")} className="btn btn-o flex-[1_1_220px]">Registra spesa</button>
        <button data-testid="cliente-apri-ricevuta" onClick={() => onAzione("ricevuta")} className="btn btn-g flex-[1_1_220px]">Emetti ricevuta / fattura</button>
      </div>

      <div className="sub" data-testid="cliente-documenti-emessi">
        <div className="subt">
          <span>Documenti emessi</span>
          <span className="text-[12px] font-normal normal-case tracking-normal text-[#5A5A5A]">totale fatturato {eur(c.fatturato)}</span>
        </div>
        {documenti.length === 0 ? (
          <div className="riga text-[#5A5A5A]" data-testid="cliente-documenti-emessi-vuoto">Nessuna ricevuta o fattura emessa.</div>
        ) : documenti.map((d) => (
          <div key={d.id} data-testid={`documento-emesso-${d.id}`} className="riga flex-wrap gap-y-1">
            <span className="w-[92px] shrink-0 text-[#4A4A48]">{d.data}</span>
            <span className="flex-[999_1_180px] min-w-0">
              {d.documento_id || d.drive_link ? (
                <a href={d.documento_id ? viewUrl(d.documento_id) : d.drive_link} target="_blank" rel="noreferrer"
                  className="font-semibold no-underline">{d.etichetta} {d.numero_completo}</a>
              ) : <span className="font-semibold">{d.etichetta} {d.numero_completo}</span>}
              {d.causale ? <span className="text-[#4A4A48]"> · {d.causale}</span> : null}
            </span>
            <span className="w-[110px] text-right font-bold">{eur(d.importo)}</span>
            <span className={`w-[110px] text-[13px] font-bold ${TONO[d.stato] || ""}`}>{d.stato}</span>
          </div>
        ))}
        <div className="nota-tenue">
          Gli stessi numeri della scheda pratica: si ricalcolano dai movimenti, non si scrivono due volte.
          Lo stato di un documento si legge dall'incasso collegato.
        </div>
      </div>
    </>
  );
}
